import { useEffect } from "react";

export const useKeyDown = (keyName: string, callback: () => void) => {
  const keyDown = ({ key }: { key: string }) => {
    if (keyName === key) {
      callback();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", keyDown);

    return () => window.removeEventListener("keydown", keyDown);
  }, []);
};
